.clippingIconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    opacity: 1 !important;
}

.clippingIcon {
    color: inherit;
}

.clippingIndicator {
    color: var(--kl-color);
}

:global(.kl-theme-dark) {
    .clippingIndicator {
        color: #ccc;
    }
}
